



export const APP_AUTH_TOKEN ="auth@ria@2024"

export const APP_URL ="https://apis.riaug.org";
// export const APP_URL ="http://localhost:8282";
